<div class="w-12 inline-flex flex-middle">
    <!-- active filters -->
    <ng-container *ifSize="'XL'">
        @for (filter of getFiltersForChips(); track listing.filterTrackByFn($index, filter); let last = $last) {
        <button type="button"
                (click)="showFiltersModal(filter)"
                [ngClass]="!last ? 'm-r-5' : 'm-r-3'"
                class="filter-button p1 bg-col-51 p-r-2 p-l-2">
            {{getFilterButtonLabel(asFilterAttributeOption(filter))}}
        </button>
        }
    </ng-container>

    <!-- filters modal button -->
    @if (displayFiltersButton) {
    <button type="button"
            class="filter-button p1 bg-col-w col-6 m-r-3 m-r-2-s m-r-2-m p-r-2 p-l-2 p-r-4-s p-r-4-m p-l-4-s p-l-4-m b-a b-col-6"
            (click)="showFiltersModal()">
        {{(isMobileView ? 'Filter' : 'More Filters' + (moreFiltersOptionsCount ? (' (' + moreFiltersOptionsCount + ')' )
        : '')) | translate }}</button>
    }

    <!-- listing sort mobile -->
    <ng-container *ifSize="'SM'">
        <button type="button"
                class="filter-button p1 bg-col-w col-6 p-r p-l b-a b-col-6"
                (click)="showFiltersModal()">
            {{'Sort' | translate }}</button>
    </ng-container>

    <!-- horizontal fill mobile -->
    <div *ifSize="'SM'"
         class="flex-grow"></div>

    <!-- number of items -->
    <p class="col-11"
       sizeClass="SM: p2 lowercase, XL: p1">
        {{('% Product' + (listing.length === 1 ? '' : 's')) | translate : listing.length || 0 }}
    </p>

    <!-- horizontal fill -->
    <div *ifSize="'XL'"
         class="flex-grow"></div>

    <!-- listing size -->
    @if (listing?.size) {
    <listing-size [size]="listingSize" />
    }

    <!-- listing sort -->
    <ng-container *ifSize="'XL'">
        <button type="button"
                class="filter-button p1 bg-col-w p-r-2 p-l-2 b-a b-col-1 m-l"
                (click)="showFiltersModal()">
            {{'Sort by' | translate }}</button>
    </ng-container>
</div>

<filter-prerender-links [listing]="listing" />